var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_14532_170756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 55,
    height: 56,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 24C36.5333 24 33.6332 24.8797 31.1665 26.528C28.6997 28.1762 26.7771 30.5189 25.6418 33.2597C24.5065 36.0006 24.2094 39.0166 24.7882 41.9264C25.367 44.8361 26.7956 47.5088 28.8934 49.6066C30.9912 51.7044 33.6639 53.133 36.5737 53.7118C39.4834 54.2906 42.4994 53.9935 45.2403 52.8582C47.9811 51.7229 50.3238 49.8003 51.972 47.3336C53.6203 44.8668 54.5 41.9667 54.5 39C54.5 37.0302 54.112 35.0796 53.3582 33.2597C52.6044 31.4399 51.4995 29.7863 50.1066 28.3934C48.7137 27.0005 47.0601 25.8956 45.2403 25.1418C43.4204 24.388 41.4698 24 39.5 24V24ZM26.3667 39C26.3565 36.4854 27.0694 34.0209 28.4203 31.9001C29.7713 29.7792 31.7034 28.0914 33.9866 27.0376C36.2697 25.9838 38.8077 25.6086 41.2981 25.9565C43.7885 26.3044 46.1264 27.3609 48.0333 29L29.6 47.6667C27.5002 45.2695 26.3501 42.1868 26.3667 39V39ZM39.5 52.1167C36.3438 52.1191 33.2939 50.9761 30.9167 48.9L49.4 30.4167C51.0408 32.3149 52.1019 34.6444 52.4573 37.1281C52.8126 39.6119 52.4472 42.1455 51.4044 44.4276C50.3616 46.7097 48.6854 48.6444 46.5751 50.0016C44.4648 51.3587 42.0091 52.0813 39.5 52.0833V52.1167Z",
    fill: "#0089EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_14532_170756",
    x: 0,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14532_170756"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14532_170756",
    result: "effect2_dropShadow_14532_170756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_14532_170756",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedArea);
export default __webpack_public_path__ + "static/media/restricted-area.49237ea975d04da8912c9d1dbafddcc2.svg";
export { ForwardRef as ReactComponent };